import { securedAxios } from "../lib/axios";
export default {
  namespaced: true,
  state: {
    subGrupoItem: [],
    grupoItem: [],
    fakeID: 4,
  },
  mutations: {
    carregarSubGrupoItem(state, grupos) {
      state.subGrupoItem = grupos;
    },
    gravarSubGrupoItem(state) {
      state.fakeID++;
    },
    buscarSubGrupoItem(state, response) {
      state.subGrupoItem = response;
    },
    carregarGrupoItem(state, response) {
      state.grupoItem = response;
    },
  },
  actions: {
    async listar({ commit }) {
      try {
        const response = await securedAxios.get("/sub-grupo-item");
        commit("carregarSubGrupoItem", response.data);
        return Promise.resolve(true);
      } catch (err) {
        commit("carregarSubGrupoItem", []);
        return Promise.reject(err);
      }
    },
    buscar(context, aFiltro) {
      try {
        var filtro = aFiltro.filtro ? aFiltro.filtro : "";
        var valor = aFiltro.valor ? aFiltro.valor : "";

        securedAxios
          .get("/sub-grupo-item?" + filtro + "=" + valor)
          .then((response) =>
            context.commit("buscarSubGrupoItem", response.data)
          );

        return Promise.resolve(true);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async gravar(context, SubGrupoItemInfo) {
      try {
        var id = SubGrupoItemInfo.id;

        if (id == "") {
          var infoNovo = {
            id: this.state.fakeID,
            descricao: SubGrupoItemInfo.descricao,
            codigo: SubGrupoItemInfo.codigo,
            id_grupoitem: SubGrupoItemInfo.id_grupoitem,
          };
          await securedAxios.post("/sub-grupo-item", infoNovo);
        } else {
          var infoAltera = {
            descricao: SubGrupoItemInfo.descricao,
            codigo: SubGrupoItemInfo.codigo,
            id_grupoitem: SubGrupoItemInfo.id_grupoitem,
          };
          await securedAxios.put("/sub-grupo-item/" + id, infoAltera);
        }

        return Promise.resolve(true);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async deletar(context, id) {
      try {
        await securedAxios.delete("/sub-grupo-item/" + id.id);
        return Promise.resolve(true);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async carregarSubGrupoItem(context, id) {
      try {
        const response = await securedAxios.get("/sub-grupo-item/" + id.id);
        return Promise.resolve(response);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async carregarGrupoItem(context) {
      try {
        const response = await securedAxios.get("/grupoitem");
        context.commit("carregarGrupoItem", response.data);
        return Promise.resolve(true);
      } catch (err) {
        return Promise.reject(err);
      }
    },
  },
};
